// Para birimi lookup tablosu
export const CURRENCY_SYMBOLS = {
    1: '₺',
    2: '$',
    3: '€',
} as const;

// Para birimi kodları için lookup tablosu
export const CURRENCY_CODES = {
    1: 'TRY',
    2: 'USD',
    3: 'EUR',
} as const;

// Para birimi isimleri için lookup tablosu
export const CURRENCY_NAMES = {
    1: 'TL',
    2: 'Dolar',
    3: 'Euro',
} as const;

// Para birimi tiplerini tanımla
export type CurrencyId = keyof typeof CURRENCY_SYMBOLS;

/**
 * Para birimi ID'sine göre sembol döndürür
 * @param currencyId - Para birimi ID'si ('1', '2', '3')
 * @returns Para birimi sembolü (₺, $, €) veya varsayılan olarak '₺'
 */
export const getCurrencySymbol = (currencyId: string | number): string => {
    const id = (currencyId) as CurrencyId;
    return CURRENCY_SYMBOLS[id] || '₺';
};

/**
 * Para birimi ID'sine göre kod döndürür
 * @param currencyId - Para birimi ID'si ('1', '2', '3')
 * @returns Para birimi kodu (TRY, USD, EUR) veya varsayılan olarak 'TRY'
 */
export const getCurrencyCode = (currencyId: string | number): string => {
    const id = (currencyId) as CurrencyId;
    return CURRENCY_CODES[id] || 'TRY';
};

/**
 * Para birimi ID'sine göre isim döndürür
 * @param currencyId - Para birimi ID'si ('1', '2', '3')
 * @returns Para birimi ismi veya varsayılan olarak 'Türk Lirası'
 */
export const getCurrencyName = (currencyId: string | number): string => {
    const id = (currencyId) as CurrencyId;
    return CURRENCY_NAMES[id] || 'Türk Lirası';
};

/**
 * Tüm para birimlerini döndürür
 * @returns Para birimi bilgilerinin listesi
 */
export const getAllCurrencies = () => {
    return Object.keys(CURRENCY_SYMBOLS).map(id => {
        const numericId = Number(id) as CurrencyId;
        return {
            id: numericId,
            symbol: CURRENCY_SYMBOLS[numericId],
            code: CURRENCY_CODES[numericId],
            name: CURRENCY_NAMES[numericId],
        };
    });
};

/**
 * DataGrid için para birimi seçeneklerini döndürür
 * @returns valueOptions formatında para birimi listesi
 */
export const getCurrencyValueOptions = () => {
    return Object.keys(CURRENCY_SYMBOLS).map(id => {
        const numericId = Number(id) as CurrencyId;
        return {
            value: numericId,
            label: `${CURRENCY_NAMES[numericId]}`
        };
    });
};

/**
 * Para birimi için tam format döndürür (tutar + sembol)
 * @param amount - Tutar
 * @param currencyId - Para birimi ID'si
 * @param locale - Yerel ayar (varsayılan: 'tr-TR')
 * @returns Formatlanmış para birimi string'i
 */
export const formatCurrencyWithSymbol = (
    amount: number,
    currencyId: string | number,
    locale: string = 'tr-TR'
): string => {
    const symbol = getCurrencySymbol(currencyId);
    const formattedAmount = new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(amount);

    return `${formattedAmount} ${symbol}`;
};
